import { render } from "./BaseNode.vue?vue&type=template&id=e3e3334a&scoped=true"
import script from "./BaseNode.vue?vue&type=script&lang=js"
export * from "./BaseNode.vue?vue&type=script&lang=js"

import "./BaseNode.vue?vue&type=style&index=0&id=e3e3334a&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3e3334a"]])

export default __exports__